export const STORE_CLOSED = 'Closed'
export const PAGES_WHERE_HIDE_CALL_STORE_INFO = ['regions', 'promo', 'lowest-tire-price-guarantee', 'deals']
